import { render } from "./contracts-list.vue?vue&type=template&id=4362d20e"
import script from "./contracts-list.vue?vue&type=script&lang=js"
export * from "./contracts-list.vue?vue&type=script&lang=js"

import "./contracts-list.vue?vue&type=style&index=0&id=4362d20e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__